import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ButtonToolbar, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class Dialog extends Component {

    constructor(props) {
        super(props);
    }

    renderFooter() {
        const { footer, onHide, t } = this.props;
        const closeButton = <Button onClick={onHide}>{t('Common_Close')}</Button>;
        let content;
        if (footer) {
            content = footer;
        } else {
            content = closeButton;
        }

        return (
            <Modal.Footer>
                {content}
            </Modal.Footer>
        );
    }

    renderHeader() {
        const { header } = this.props;
        return (
            <Modal.Header closeButton>
                <Modal.Title>
                    {header}
                </Modal.Title>
            </Modal.Header>
        );
    }

    renderBody() {
        const { body } = this.props;
        return (
            <Modal.Body>
                {body}
            </Modal.Body>
        );
    }

    render() {
        const { header, body, footer, onHide, show, block, unblock, t, ...rest } = this.props;
        return <Modal
            show={show}
            onHide={onHide}
            {...rest}
        >
            <ReduxBlockUi block={block} unblock={unblock}>
                {this.renderHeader()}
                {this.renderBody()}
                {this.renderFooter()}
            </ReduxBlockUi>
        </Modal>;
    }
}

Dialog.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    header: PropTypes.node,
    body: PropTypes.node,
    footer: PropTypes.node
};

export default withTranslation()(Dialog);